import { useCallback } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { GetStakingRiskProductsUserInfoThunk } from "../../../Thunks/StakingRiskThunk";
import { StakingRiskRightDetails } from "./StakingRiskRightDetails";
import styles from "../StakingRiskDetails/staking-risk.module.css";
import StakingRiskAside from "../../../Components/StakingRiskAside";
import { StakingCardLeft } from "./StakingCardLeft";
import { Header } from "../../../Components";

function useElementScroll(ref) {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const handleScroll = () => setScrollY(element.scrollTop);

    element.addEventListener("scroll", handleScroll);
    return () => element.removeEventListener("scroll", handleScroll);
  }, [ref]);

  return scrollY;
}

export function StakingRiskDetails() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { id: productId } = useParams();
  const containerRef = useRef(null);
  const scrollY = useElementScroll(containerRef);

  const openMenu = useSelector((state) => state.menu.open);
  const products = useSelector((state) => {
    return state.StakingRiskReducer.stakingRiskProductsListUserInfo;
  });

  const savedScroll = sessionStorage.getItem("stakingRiskScrollY");

  const [modalIsOpen, setIsOpen] = useState(false);
  const [activeId, setActiveId] = useState(null);

  useEffect(() => {

    if (savedScroll || scrollY > 0) {
      setTimeout(() => {
        containerRef.current.scrollTo = parseInt(savedScroll, 10);
      }, 10);
    }
  }, []);

  useEffect(() => {
    if (!products?.length) {
      dispatch(GetStakingRiskProductsUserInfoThunk({ selected: true }));
    }
  }, [products, dispatch]);

  useEffect(() => {
    if (products?.length > 0 && !activeId) {
      setActiveId(+productId);
    }
  }, [products, activeId]);

  const searchParams = new URLSearchParams(location.search);
  const [search, setSearch] = useState(searchParams.get("search") || "");

  const handleSearchChange = useCallback(
    (e) => {
      const value = e.target.value;
      setSearch(value);
      dispatch(GetStakingRiskProductsUserInfoThunk({ search: value, selected: true }));
    },
    [dispatch]
  );

  const [zoomActive, setZoomActive] = useState(false);
  useEffect(() => {
    const storedZoom = localStorage.getItem("zoomActive");
    setZoomActive(storedZoom);
  }, [localStorage.getItem("zoomActive")]);

  return (<>
    <Header title="Staking Risk" />
    <main className={`main ${openMenu ? "open" : "main"}`}>
      <div className="content" id="scrollContent">
        <div className="row">
          <div className={styles["staking-risk-details-wrapper"]}>
            <div className={styles["staking-risk-details-left"]}>
              <div className={styles["staking-risk-details-inner"]}>
                <div
                  className="listening_search_wrapper"
                  style={{ width: "15%", marginTop: "20px", position: "fixed", zIndex: "10", left: "6.2%" }}
                >
                  <div className="listening_search_icon_wrapper" />
                  <input
                    type="text"
                    className="listening_search_field"
                    placeholder="Search..."
                    style={{ height: "33px" }}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
              {Array.isArray(products) && products.length > 0 ? (
                <StakingCardLeft
                  activeId={activeId}
                  setActiveId={setActiveId}
                  containerRef={containerRef}
                  zoomActive={zoomActive} />
              ) : (
                <p style={{ marginTop: "70px", }}>
                  No staking products available.
                </p>
              )}
            </div>
            <div className={styles["staking-risk-details-right"]} ref={containerRef} >
              {activeId && (
                <StakingRiskRightDetails
                  activeId={activeId}
                  setActiveId={setActiveId}
                  scrollY={scrollY}
                  containerRef={containerRef}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <StakingRiskAside
        openModal={(event) => {
          setIsOpen(event);
        }} />
    </main>
  </>
  );
}